import { useState } from 'react';
import { Box, Button, IconButton, Typography } from '@mui/material';
import NoteDetailDialog from './NoteDetailDialog';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Note from './Note';
import CardNoteDTO from '@src/adapters/dto/card/CardNoteDTO';
import { CardNoteType } from '@src/constants/CardNoteType';

interface Props {
  isEdit: boolean;
  cardId: string;
  notes: CardNoteDTO[];
  type: CardNoteType;
  onNoteUpdated(note: CardNoteDTO): void;
  onNoteDeleted(noteId: string): void;
}

function Notes({
  isEdit,
  cardId,
  notes,
  onNoteUpdated,
  onNoteDeleted,
  type,
}: Props) {
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState(true);

  const handleAddNote = () => {
    setOpen(true);
  };

  const handleClose = (note: CardNoteDTO | undefined) => {
    if (note) {
      onNoteUpdated(note);
    }
    setOpen(false);
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          height: '62px',
          backgroundColor: '#f5f7fd',
          border: '1px solid #E6E7E9',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
        <Typography
          variant="h6"
          sx={(theme) => ({ marginLeft: theme.spacing(3) })}>
          {type} Notes
        </Typography>

        <Box>
          {isEdit && (
            <Button
              variant="outlined"
              size="small"
              color="primary"
              startIcon={<AddCircleIcon />}
              onClick={handleAddNote}>
              Add Note
            </Button>
          )}

          <IconButton
            aria-label="logout"
            onClick={() => setExpanded((prev) => !prev)}
            size="large"
            sx={(theme) => ({ marginRight: theme.spacing(1) })}>
            {expanded && <ExpandLessIcon />}
            {!expanded && <ExpandMoreIcon />}
          </IconButton>
        </Box>
      </Box>

      {expanded &&
        notes
          .filter((n) => n.type === type)
          .map((n) => (
            <Note
              cardId={cardId}
              note={n}
              noteUpdated={onNoteUpdated}
              noteDeleted={onNoteDeleted}
              key={n.id}
              isEdit={isEdit}
            />
          ))}
      {expanded && notes.length === 0 && (
        <Typography
          variant="body1"
          color={(theme) => theme.palette.text.disabled}
          sx={(theme) => ({ padding: theme.spacing(3) })}>
          No {type.toLocaleLowerCase()} notes to show.
        </Typography>
      )}
      <NoteDetailDialog
        isOpen={open}
        onClose={handleClose}
        cardId={cardId}
        type={type}
      />
    </>
  );
}

export default Notes;
